/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatMessageReviewQueryVariables = Exact<{
  userId: string | number;
}>;


export type ChatMessageReviewQuery = { review: { score: number, review: string, status: string } | null };


export const ChatMessageReviewDocument = gql`
    query ChatMessageReview($userId: ID!) {
  review(userId: $userId) {
    score
    review
    status
  }
}
    `;

/**
 * __useChatMessageReviewQuery__
 *
 * To run a query within a Vue component, call `useChatMessageReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMessageReviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatMessageReviewQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useChatMessageReviewQuery(variables: ChatMessageReviewQueryVariables | VueCompositionApi.Ref<ChatMessageReviewQueryVariables> | ReactiveFunction<ChatMessageReviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatMessageReviewQuery, ChatMessageReviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatMessageReviewQuery, ChatMessageReviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatMessageReviewQuery, ChatMessageReviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChatMessageReviewQuery, ChatMessageReviewQueryVariables>(ChatMessageReviewDocument, variables, options);
}
export function useChatMessageReviewLazyQuery(variables?: ChatMessageReviewQueryVariables | VueCompositionApi.Ref<ChatMessageReviewQueryVariables> | ReactiveFunction<ChatMessageReviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatMessageReviewQuery, ChatMessageReviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatMessageReviewQuery, ChatMessageReviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatMessageReviewQuery, ChatMessageReviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChatMessageReviewQuery, ChatMessageReviewQueryVariables>(ChatMessageReviewDocument, variables, options);
}
export type ChatMessageReviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChatMessageReviewQuery, ChatMessageReviewQueryVariables>;